import { useEffect } from 'react';

const SEO = ({ title, description, keywords, ogImage, ogType = 'website' }) => {
  const siteName = "Pups & Dreams Spa & Academy";
  const defaultDescription = "Professional dog grooming salon and CPD accredited training academy in Denton, Manchester. Award-winning grooming services for all breeds in Greater Manchester.";
  const defaultKeywords = "dog grooming Manchester, dog grooming Denton, Manchester dog groomers, puppy grooming Manchester, dog grooming academy Manchester, dog grooming course Manchester, pet spa Manchester";
  const defaultImage = "https://customer-assets.emergentagent.com/job_pups-dreams-spa/artifacts/ncduemn0_IMG_5734.jpeg";

  useEffect(() => {
    // Update title
    document.title = title ? `${title} | ${siteName}` : siteName;

    // Helper function to update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Standard meta tags
    updateMetaTag('description', description || defaultDescription);
    updateMetaTag('keywords', keywords || defaultKeywords);

    // Open Graph tags
    updateMetaTag('og:title', title ? `${title} | ${siteName}` : siteName, true);
    updateMetaTag('og:description', description || defaultDescription, true);
    updateMetaTag('og:type', ogType, true);
    updateMetaTag('og:image', ogImage || defaultImage, true);
    updateMetaTag('og:site_name', siteName, true);

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title ? `${title} | ${siteName}` : siteName);
    updateMetaTag('twitter:description', description || defaultDescription);
    updateMetaTag('twitter:image', ogImage || defaultImage);

  }, [title, description, keywords, ogImage, ogType]);

  return null;
};

export default SEO;
